import React from "react";
import { Tabs } from "antd";

import ApiGettingStarted from "./ApiGettingStarted";
import ApiEndpoints from "./ApiEndpoints";
import ApiFieldReference from "./ApiFieldReference";

const ApiDocumentation = () => {
  const items = [
    {
      key: "getting-started",
      label: "Getting Started",
      children: <ApiGettingStarted />,
    },
    {
      key: "api-keys",
      label: "Authentication",
      children: <AuthenticationGuide />,
    },
    {
      key: "endpoints",
      label: "Endpoints",
      children: <ApiEndpoints />,
    },
    {
      key: "fields",
      label: "Field Reference",
      children: <ApiFieldReference />,
    },
  ];

  return (
    <div className="api-documentation">
      <Tabs defaultActiveKey="getting-started" items={items} />
    </div>
  );
};

const AuthenticationGuide = () => {
  return (
    <div className="api-doc-section">
      <h3>API Authentication</h3>

      <p>
        All Public CRM API requests must include a valid API key using the
        Authorization header.
      </p>

      <pre className="api-code-block">
        {`Authorization: Bearer ferp_live_your_api_key`}
      </pre>

      <p>
        API keys are branch-specific. Requests can only access CRM data
        belonging to the branch associated with the key.
      </p>

      <h4>Permissions</h4>

      <p>Each API key can be granted individual permissions:</p>

      <pre className="api-code-block">
        {`leads.create
leads.read
leads.update
leads.notes`}
      </pre>

      <p>
        If an API key attempts an operation without the required permission, the
        API returns:
      </p>

      <pre className="api-code-block">
        {`HTTP 403

{
  "success": false,
  "error": {
    "code": "PERMISSION_DENIED",
    "message": "API key does not have leads.update permission."
  }
}`}
      </pre>
    </div>
  );
};

export default ApiDocumentation;
